<template>
  <div class="settings-page">
    <div class="page-title">账号设置</div>

    <div class="settings-card">
      <div class="card-title">修改管理员账号密码</div>

      <div class="field">
        <label>当前密码</label>
        <input v-model="currentPwd" type="password" placeholder="请输入当前密码" />
      </div>
      <div class="field">
        <label>新用户名</label>
        <input v-model="newUsername" type="text" placeholder="请输入新用户名" />
      </div>
      <div class="field">
        <label>新密码</label>
        <input v-model="newPwd" type="password" placeholder="请输入新密码" />
      </div>
      <div class="field">
        <label>确认新密码</label>
        <input v-model="confirmPwd" type="password" placeholder="请再次输入新密码" />
      </div>

      <div class="msg" v-if="msg" :class="msgType">{{ msg }}</div>

      <button class="save-btn" @click="save">保存修改</button>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';

export default {
  name: 'AdminSettings',
  data() {
    return {
      currentPwd: '',
      newUsername: '',
      newPwd: '',
      confirmPwd: '',
      msg: '',
      msgType: ''
    };
  },
  methods: {
    async save() {
      this.msg = '';
      if (!this.currentPwd.trim()) {
        this.msg = '请输入当前密码';
        this.msgType = 'error';
        return;
      }
      const username = this.newUsername.trim();
      const pwd = this.newPwd.trim();
      if (!username && !pwd) {
        this.msg = '请至少填写新用户名或新密码';
        this.msgType = 'error';
        return;
      }
      if (pwd && pwd !== this.confirmPwd) {
        this.msg = '两次密码输入不一致';
        this.msgType = 'error';
        return;
      }
      try {
        const data = await api.put('/api/admin/settings', {
          currentPassword: this.currentPwd,
          newUsername: username,
          newPassword: pwd
        });
        if (data.code === 200) {
          this.currentPwd = '';
          this.newUsername = '';
          this.newPwd = '';
          this.confirmPwd = '';
          this.msg = '修改成功';
          this.msgType = 'success';
        } else {
          this.msg = data.message || '修改失败';
          this.msgType = 'error';
        }
      } catch {
        this.msg = '网络错误';
        this.msgType = 'error';
      }
    }
  }
};
</script>

<style scoped>
.settings-page {
  padding: 20px;
  max-width: 520px;
}
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
}
.settings-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.field {
  margin-bottom: 16px;
}
.field label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 500;
}
.field input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
}
.field input:focus {
  border-color: #27ae60;
}
.msg {
  font-size: 13px;
  margin-bottom: 14px;
  text-align: center;
}
.msg.error { color: #e74c3c; }
.msg.success { color: #27ae60; }
.save-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(39,174,96,0.3);
}
</style>
